import { render, staticRenderFns } from "./EnslavedHintsModal.vue?vue&type=template&id=8991864a&scoped=true"
import script from "./EnslavedHintsModal.vue?vue&type=script&lang=js"
export * from "./EnslavedHintsModal.vue?vue&type=script&lang=js"
import style0 from "./EnslavedHintsModal.vue?vue&type=style&index=0&id=8991864a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8991864a",
  null
  
)

export default component.exports